import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType } from '@contact/upgrade';

import { AGENT_GUARDS } from './agent.guard';
import { AgentCoreForRootModule } from './core/agent-core-for-root.module';

@NgModule({
  imports: [AgentCoreForRootModule.instance()],
})
export class AgentForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: AgentForRootModule) {
    if (parentModule) throw new Error(`[AgentForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<AgentForRootModule> {
    return {
      ngModule: AgentForRootModule,
      providers: [
        AGENT_GUARDS,

        // agent declaration
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.CSR,
            type: TileType.STANDARD,
            icon: 'tile_agent',
            color: Color.BLUE,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
          } as Tile,
          multi: true,
        },
      ],
    };
  }
}
